import { Controller } from '@hotwired/stimulus';
import flatpickr from 'flatpickr';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';

/**
 * 日付入力欄の制御
 */
export default class extends Controller {
  static override targets = ['input'];

  declare readonly inputTarget: HTMLInputElement;
  declare picker: flatpickr.Instance | undefined;

  override connect() {
    this.initializeFlatpickr();
  }

  override disconnect() {
    if (this.picker) {
      this.picker.destroy();
      this.picker = undefined;
    }
  }

  /**
   * Flatpicker初期化
   */
  private initializeFlatpickr() {
    const options = {
      locale: Japanese,
      dateFormat: 'Y-m-d',
      enableTime: false,
    };

    this.picker = flatpickr(this.inputTarget, options);
  }
}

